// extracted by mini-css-extract-plugin
module.exports = {"link":"case-study-card-module--link--JNfGe","compact":"case-study-card-module--compact--2BWfL"};